const apiKey = '01bcec277d5d77f570c5d79e10079e17';

export default apiKey;
